import React, { useEffect, useState } from 'react';

const SumOmset = (param) => {

    const [saldoOmset,setSaldoOmset] = useState([]);


    const formatNumberWithoutDecimals = (num) => {
        // convert num into float
        num = parseFloat(num);
        if (isNaN(num)) {
        return '0';
        }
        return num.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    };
    useEffect(() => {
        setSaldoOmset(param.SaldoOmset);
    });
    return (
        <div>
            <table style={{ width:'100%'}} className="table table-bordered">
                <thead>
                    <tr>
                        <th style={{ width: '120px'}}>Keterangan</th>
                        <th style={{ width: '120px'}}>Nilai</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(saldoOmset).map((item, index) => (
                        <tr key={index}>
                            <td>{saldoOmset[item].title}</td>
                            <td style={{ textAlign:"right"}} className={saldoOmset[item].nilai < 0 ? 'red-text' : null}>{formatNumberWithoutDecimals(saldoOmset[item].nilai)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SumOmset;